import {
  SimpleFormComponentStoreData,
  SerializeType, SimpleFormSerialize, SerializeMapping,
  FormWireData, FormWireItem, FormWireArray
} from './types';
import { normalizeValue } from './utils';

import get from 'lodash/get';

export const serializeData = (componentData: SimpleFormComponentStoreData, values: any, serializeMapping: SerializeMapping) => {
  return Object.keys(componentData).reduce((memo, key) => {
    if (componentData[key].serialize) {
      const { type, formName } = componentData[key].serialize;
      const valueKey = formName || key;
      if (values[key]) {
        memo[valueKey] = serializeMapping[type](values[key].value, memo[valueKey], componentData[key].serialize, values);
      }
    }
    return memo;
  }, {} as FormWireData);
};

export const serialize = (path: string | string[], state: any) => (serializeMapping: SerializeMapping) => {
  const areaState = get(state, path);
  const values = get(areaState, 'simpleForm.editing.values') || {};
  const componentData: SimpleFormComponentStoreData = get(areaState, 'simpleForm.componentData') || {};
  return serializeData(componentData, values, serializeMapping);
};

export const defaultSerializeMappings = {
  [SerializeType.PRIMITIVE_VALUE]:
    (storeValue, currentWireOutput: FormWireItem, options: SimpleFormSerialize) => normalizeValue(storeValue),
  [SerializeType.V_VALUE]: (storeValue, currentWireOutput: FormWireItem, options: SimpleFormSerialize) =>
    (storeValue ? { v: storeValue.value } : {}),
  [SerializeType.MULTIPLE_V_VALUES]: (storeValue, currentWireOutput: FormWireItem, options: SimpleFormSerialize) =>
    (storeValue ? storeValue.map(v => ({ v: v.value })) : []),
  [SerializeType.VALUE_PAIRS]: (storeValue, currentWireOutput: FormWireItem, options: SimpleFormSerialize, allValues: any) => {
    const value = normalizeValue(storeValue);
    const groupValue = (allValues[options.groupField] || {}).value;
    const group = normalizeValue(groupValue);
    return [
      ...((currentWireOutput || []) as FormWireArray),
      ...((!!value) ? [{
        [options.valueKey]: value,
        [options.groupKey]: group
      }] : [])
    ] as FormWireArray;
  }
};
